import {
  login,
  logout,
  getInfo
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/token'
import router, {
  resetRouter
} from '@/router'

import local from "@/utils/local";

const state = {
  token: getToken(),
  name: '',
  phone: '',
  avatar: '',
  introduction: '',
  roles: [],
  asyncrouter: [],
  visitor: false,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PHONE: (state, phone) => {
    state.phone = phone
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ASYNCROUTER(state, asyncRouter) {
    state.asyncRouter = asyncRouter;
  },

  SET_VISITOR: (state, visitor) => {
    state.visitor = visitor
  },
}

const actions = {
  // user login
  async login({
    commit
  }, userInfo) {
    const {
      username,
      password,
      uuid,
      code
    } = userInfo;
    let result = await login({
      username: username.trim(),
      password: password,
      uuid: uuid,
      code: code
    });

    if (result.code == 200) {
      commit('SET_TOKEN', result.data);
      setToken(result.data);
      return;
    } else {
      return Promise.reject(new Error('faile'));
    }
  },

  // get user info
  getInfo({
    commit,
    state
  }) {

    return new Promise((resolve, reject) => {
      console.log("vuex", state);
      getInfo(state.token).then(response => {
        const {
          data
        } = response
        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const {
          role,
          user,
          menu
        } = data
        const _roles = role.map((item) => {
          let name = item.name;
          return name;
        })
        commit('SET_ROLES', _roles)
        local.set("username", user.name);
        local.set("userPhone", user.phone);
        local.set("userAccount", user.account);
        local.set("visitor", false);
        console.log('执行', local.get("userPhone"));
        // local.set("user", user.name);
        // commit('SET_NAME', user.name)
        // commit('SET_PHONE', user.phone)

        console.log(1);
        // commit('SET_AVATAR', user.avatar)
        commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif') //设置头像
        // commit('SET_ASYNCROUTER', menu)
        resolve(menu)
      }).catch(error => {
        reject(error)
      })
    })
  },


  // user logout
  logout({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      if (state.token) {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')

          local.set("username", "");
          local.set("userPhone", "");
          local.set("visitor", false);
          commit('SET_ROLES', [])
          removeToken()
          resetRouter()

          // reset visited views and cached views
          // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
          // dispatch('tagsView/delAllViews', null, { root: true })

          resolve()
        }).catch(error => {
          reject(error)
        })
      } else {

        local.set("username", "");
        local.set("userPhone", "");
        local.set("visitor", false);
        commit('SET_ROLES', [])
        resetRouter()
        resolve()
      }
    })
  },
  lock({
    commit,
    state,
    dispatch
  }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        local.set("visitor", true);
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({
    commit,
    dispatch
  }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const {
      roles
    } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, {
      root: true
    })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}